import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GameAudioService } from '../../../_services/game-audio.service';
import { GlobalService } from 'src/app/_services/global.service';

type VolumeLevel = 'low' | 'mid' | 'high';

@Component({
  selector: 'app-game-sound-control',
  templateUrl: './game-sound-control.component.html',
  styleUrls: ['./game-sound-control.component.scss']
})
export class GameSoundControlComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  currLang: any = 'en';
  isMuted = false;
  volumePercent = 20;
  panelOpen = false;

  constructor(
    private gameAudioService: GameAudioService,
    private globalService: GlobalService
  ) {}

  ngOnInit(): void {
    this.globalService.getLang()
      .pipe(takeUntil(this.destroy$))
      .subscribe(lang => (this.currLang = lang));

    this.gameAudioService.isMuted$
      .pipe(takeUntil(this.destroy$))
      .subscribe(muted => (this.isMuted = muted));

    this.gameAudioService.volume$
      .pipe(takeUntil(this.destroy$))
      .subscribe(v => (this.volumePercent = Math.round(v * 100)));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get volumeLevel(): VolumeLevel {
    if (this.volumePercent < 5) return 'low';
    if (this.volumePercent < 50) return 'mid';
    return 'high';
  }

  get displayPercent(): number {
    return this.isMuted ? 0 : this.volumePercent;
  }

  get sliderFillPercent(): number {
    return this.isMuted ? 0 : this.volumePercent;
  }

  togglePanel(event: MouseEvent): void {
    event.stopPropagation();
    this.panelOpen = !this.panelOpen;
  }

  closePanel(): void {
    this.panelOpen = false;
  }

  toggleMute(event: MouseEvent): void {
    event.stopPropagation();
    this.gameAudioService.toggleMute();
  }

  onVolumeChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    const value = parseInt(target.value, 10) / 100;
    this.gameAudioService.setVolume(value);
    if (this.isMuted && value > 0) {
      this.gameAudioService.toggleMute();
    }
  }
}
